import {InjectionToken} from "@angular/core";

export const OpQueryConfigurationLocalsToken = new InjectionToken<any>('OpQueryConfigurationLocalsToken');
export const OpQueryConfigurationTriggerEvent = 'op:queryconfiguration:trigger';
